import * as React from 'react'
import styled from 'styled-components'

const Textarea = styled.textarea`
  width: 100%;
  height: 20px;
  max-height: ${props => props.maxHeight};
  font-size: ${p => (p.fontSize ? `${p.fontSize  }px` : '16px')};
  color: ${props => props.theme.color.white};
  resize: none;
  background: none;
  border: none;
  pointer-events: ${p => p.disabled && 'none'};

  ::placeholder {
    color: ${p => p.theme.color.disabled};
  }
`

export default class extends React.Component {
  componentDidMount() {
    this.props.onChange(this.props.defaultValue)
    this.updateHeight()
  }

  componentDidUpdate() {
    this.updateHeight()
  }

  updateHeight = () => {
    this.textarea.style.height = '20px'
    this.textarea.style.height = `${this.textarea.scrollHeight  }px`
  }

  render() {
    const {
      maxHeight,
      currentValue,
      onChange,
      onBlur,
      maxLength,
      autoFocus,
      disabled,
      placeholder,
      fontSize
    } = this.props
    return (
      <Textarea
        ref={el => (this.textarea = el)}
        type="text"
        value={currentValue}
        maxHeight={maxHeight}
        // eslint-disable-next-line react/jsx-no-bind
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        maxLength={maxLength}
        autoFocus={autoFocus}
        disabled={disabled}
        placeholder={placeholder}
        fontSize={fontSize}
      />
    )
  }
}
